import { defaultErrorHandler } from '@/admin-shared-modules/utils'
import { GET, POST } from '@/admin-shared-modules/utils/ajax'
import { MessageService } from '@/admin-shared-modules/utils/message.service'
import { appStore } from '@/store'
import _ from 'lodash'
import md5 from 'md5'
import qs from 'query-string'

function getHeader() {
  const t = (new Date().getTime() / 1000).toFixed().toString()
  const h = md5(`${t}t&jrCPNpJgrFkmjE`)
  return {
    timestamp: t,
    token: h
  }
}

class Store {
  list = {
    items: [],
    index: 1,
    size: 20,
    total: 0,
    loading: true
  }

  token = ''
  org = { id: 0 }

  async fetch() {
    this.list.loading = true

    try {
      const zyPageURL = _.get(appStore.state.data, 'zhuyun_page.cabinet')
      const url = new URL(zyPageURL!)
      const q = qs.parse(url.search)
      this.token = q.token as string

      const res1 = await GET(
        'https://plat.chaoxingbook.com/zypadbook/api/user/account/current',
        {
          data: { token: this.token }
        }
      )
      try {
        const id = JSON.parse((res1 as any).msg)?.data?.library?.id
        this.org = { id }
      } catch (e) {
        console.error(e)
        return
      }

      const res = await GET(
        'https://plat.chaoxingbook.com/zypadbook/api/padbookbr/cxQueryEquList',
        {
          headers: getHeader(),
          data: {
            siteId: this.org.id,
            sidx: '',
            order: 'asc',
            page: 1,
            limit: 99
          }
        }
      )
      this.list.items = (res as any).page?.list
    } catch (e) {
      defaultErrorHandler(e)
    } finally {
      this.list.loading = false
    }
  }

  setBorrow(it, val) {
    if (!onlineCheck(it)) return
    this.update({
      ...it,
      terminalBorrow: val ? 1 : 0
    })
  }
  setReturn(it, val) {
    if (!onlineCheck(it)) return
    this.update({
      ...it,
      terminalReturn: val ? 1 : 0
    })
  }

  saving = false

  async update(it) {
    if (this.saving) return
    try {
      this.saving = true
      await POST(
        'https://plat.chaoxingbook.com/zypadbook/api/padbookbr/cxSaveConfig',
        {
          headers: getHeader(),
          data: {
            equCode: it.equCode,
            terminalBorrow: it.terminalBorrow,
            terminalReturn: it.terminalReturn
          }
        }
      )
      MessageService.open({
        type: 'success',
        message: '设置成功'
      })
    } catch (e) {
      defaultErrorHandler(e)
    } finally {
      this.saving = false
      this.fetch()
    }
  }
}

function onlineCheck(it) {
  if (it.status !== '01') {
    MessageService.open({
      type: 'warning',
      message: '借还柜离线，无法进行功能开关操作'
    })
  }
  return true
}

export default new Store()
